export default "__VITE_ASSET__2zwgmNR9__"